module.exports = __webpack_public_path__ + "img/img-login.9ee6244b.svg";